export default __webpack_public_path__ + "static/media/cargando.9c48f460.gif";